import { handleErrorException, loading, success } from 'State/actions';
import { isRequestCancelation } from 'Common/Helpers';
import { ProductionGridFieldEnum as ProductionGridFields } from 'Common/FieldEnum';

import * as types from './types';

export const getSiteMenus = siteIds => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    const { Api, source } = MPWWebApi.createCancelableApi();

    dispatch(
      loading(types.MANAGE_PRODUCTION_FETCHING_MENUS, true, true, source)
    );

    const res = await Api.postGenericInsertUpdate('Production/GetSiteMenus', {
      [ProductionGridFields.SiteIds]: siteIds,
    });

    dispatch(success(types.MANAGE_PRODUCTION_SET_MENUS, res.data.Data));
    dispatch(loading(types.MANAGE_PRODUCTION_FETCHING_MENUS, false));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.MANAGE_PRODUCTION_SET_ERROR, {
        Title: 'Error',
        Message: 'Failed to load menus for the selected site.',
      })
    );

    if (!isRequestCancelation(ex)) {
      dispatch(loading(types.MANAGE_PRODUCTION_FETCHING_MENUS, false));
    }
  }
};

export const getProdRecords = data => async (dispatch, getState, MPWWebApi) => {
  try {
    const { Api, source } = MPWWebApi.createCancelableApi();
    dispatch(
      loading(
        types.MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS,
        true,
        true,
        source
      )
    );

    const res = await Api.postGenericInsertUpdate(
      'Production/GetProductionRecords',
      data
    );

    dispatch(
      success(types.MANAGE_PRODUCTION_SET_PRODUCTION_RECORDS, res.data.Data)
    );
    dispatch(
      loading(types.MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS, false)
    );
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.MANAGE_PRODUCTION_SET_ERROR, {
        Title: 'Error',
        Message: 'Failed to load production records.',
      })
    );

    if (!isRequestCancelation(ex)) {
      dispatch(
        loading(types.MANAGE_PRODUCTION_FETCHING_PRODUCTION_RECORDS, false)
      );
    }
  }
};

export const clearError = () => ({
  type: types.MANAGE_PRODUCTION_CLEAR_ERROR,
});

export const clearState = () => ({
  type: types.MANAGE_PRODUCTION_CLEAR_STATE,
});

export const closeProdRecord = id => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(
      loading(types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING, true)
    );

    const closeResponse = await MPWWebApi.postGenericInsertUpdate(
      `Production/Close/${id}`
    );
    const closedRecord = closeResponse.data.Data;

    dispatch(
      success(
        types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_SUCCESS,
        closedRecord
      )
    );

    dispatch(setCloseProductionSuccessful(true));
  } catch (ex) {
    dispatch(
      handleErrorException(
        ex,
        types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_ERROR,
        {
          Title: 'Error',
          Message: 'Failed to close production record.',
        }
      )
    );
  } finally {
    dispatch(
      loading(types.MANAGE_PRODUCTION_CLOSE_PRODUCTION_RECORD_LOADING, false)
    );
  }
};

export const reopenProdRecord = id => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(
      loading(types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_LOADING, true)
    );

    const reopenResponse = await MPWWebApi.postGenericInsertUpdate(
      `Production/Reopen/${id}`
    );
    const reopenRecord = reopenResponse.data.Data;

    dispatch(
      success(
        types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_SUCCESS,
        reopenRecord
      )
    );

    dispatch(setReopenProductionSuccessful(true));
  } catch (ex) {
    dispatch(
      handleErrorException(
        ex,
        types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_ERROR,
        {
          Title: 'Error',
          Message: 'Failed to reopen production record.',
        }
      )
    );
  } finally {
    dispatch(
      loading(types.MANAGE_PRODUCTION_REOPEN_PRODUCTION_RECORD_LOADING, false)
    );
  }
};

export const setCloseProductionSuccessful = successful => ({
  type: types.MANAGE_PRODUCTION_SET_CLOSE_PRODUCTION_SUCCESSFUL,
  payload: successful,
});

export const setReopenProductionSuccessful = successful => ({
  type: types.MANAGE_PRODUCTION_SET_REOPEN_PRODUCTION_SUCCESSFUL,
  payload: successful,
});



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/manageproduction/actions.js